module.exports = __webpack_public_path__ + "img/cloud.ed29e62d.png";